const fonts = 
{
	normal: 'Roboto',
	thick: 'Archivo Black'
}

export default fonts;